<template>
    <div>
        <CCol sm="12">
            <CCard>
                <CCardBody class="d-flex flex-column">
                    <!-- Title -->
                    <h2 class="col-lg-12 text-center mb-3">{{ $t('profile') }}</h2>
                    <!-- Password -->
                    <CRow>
                        <CCol sm="12">
                            <CInput class="mb-2" :label="$t('newPassword')" :type="showPassword ? 'text' : 'password'"
                                v-model="password" :is-valid="passwordValidator() && errorValidator('Password')"
                                :invalid-feedback="errorOutput['Password']"></CInput>
                            <input type="checkbox" id="showPassword" v-model="showPassword" />
                            <label class="mx-2" for="showPassword" @chnage="showPassword = !showPassword">Show
                                password</label>
                        </CCol>
                    </CRow>
                    <!-- Confirm password -->
                    <CRow>
                        <CCol sm="12">
                            <CInput class="mb-2" :label="$t('confirmNewPassword')"
                                :type="showConfirmPassword ? 'text' : 'password'" v-model="confirmPassword"
                                :is-valid="passwordValidator() && errorValidator('Password')"
                                :invalid-feedback="errorOutput['Password']"></CInput>
                            <input type="checkbox" id="showConfirmPassword" v-model="showConfirmPassword" />
                            <label class="mx-2" for="showConfirmPassword"
                                @chnage="showConfirmPassword = !showConfirmPassword">Show password</label>
                        </CCol>
                    </CRow>
                    <!-- API errors that belong to no field above -->
                    <FormApiErrors :fields="['Password']"></FormApiErrors>
                    <!-- Action button -->
                    <CCol class="d-flex justify-content-end mt-3">
                        <CRow sm="2" class="align-self-end">
                            <CSpinner v-if="loading" variant="success" small></CSpinner>
                            <CButton v-else type="button" class="btn btn-primary" @click="submitClicked">{{
                                $t('acceptChanges') }}</CButton>
                        </CRow>
                    </CCol>
                </CCardBody>
            </CCard>
        </CCol>
        <ConfirmationPopUp :confirmationMessage="confirmationMessage" @closeConfirmRequested="onClickConfirmationPopup"
            v-model="showConfirmationPopup"></ConfirmationPopUp>
    </div>
</template>
 
<script>
import FormApiErrors from '@/controls/FormApiErrors.vue';
import { mapState, mapActions } from 'vuex'
import ConfirmationPopUp from "@/controls/popups/ConfirmationPopUp.vue";

export default {
    components: { FormApiErrors, ConfirmationPopUp },
    data() {
        return {
            triedSubmit: false,
            password: '',
            confirmPassword: '',
            loading: false,
            showConfirmationPopup: false,
            confirmationMessage: "",
            showPassword: false,
            showConfirmPassword: false
        }
    },

    computed:
    {
        ...mapState({
            alertType: state => state.alert.type,
            alertOutput: state => state.alert.output
        }),
        errorOutput: function () {
            var result = [];

            if (this.alertType == 'alert-danger' && this.alertOutput && Array.isArray(this.alertOutput)) {
                result = this.alertOutput.reduce(function (accum, currentVal) {
                    accum[currentVal.key] = currentVal.value;
                    return accum;
                }, {});
            }

            // Validate password
            if (this.triedSubmit && (this.password || this.confirmPassword)) {
                // It is necessary to validate the passwords
                var passwordPattern = /(?=.*[A-Za-z])(?=.*\d).{6,}$/g;

                if (this.password != this.confirmPassword) {
                    result['Password'] = this.$i18n.t("noMatchPassword");
                }
                else if (!this.password.match(passwordPattern)) {
                    result['Password'] = this.$i18n.t("forbiddenPassword");
                }
            }

            return result;
        },
        ...mapState('users', ['user']),
        ...mapState('users', ['processTask']),
        isPasswordValid: function () {
            return this.passwordValidator() != false;
        },
    },
    methods: {
        ...mapActions('users', ['updatePassword']),
        onClickConfirmationPopup(value) {
            this.showConfirmationPopup = value;
        },
        submitClicked() {
            this.triedSubmit = true;
            if (this.isPasswordValid) {
                this.loading = true;
                this.updatePassword(this.password);
            }
        },
        passwordValidator() {
            var result = undefined;

            if (this.triedSubmit) {
                if (this.password && this.confirmPassword) {
                    // It is necessary to validate the passwords
                    var passwordPattern = /(?=.*[A-Za-z])(?=.*\d).{6,}$/g;
                    result = this.password == this.confirmPassword && this.password.match(passwordPattern);
                } else {
                    result = false;
                }
            }
            return result;
        },
        errorValidator(fieldName) {
            var result = undefined;

            if (this.alertOutput && Array.isArray(this.alertOutput)) // Error alertOutput
            {
                if (this.alertOutput.find(obj => {
                    return obj.key === fieldName
                })) {
                    result = false;
                }
            }

            return result;
        }
    },
    watch:
    {
        processTask: function (val) {
            if(val !== null) {
                if (val) {
                    this.password = '';
                    this.confirmPassword = '';
                    this.showPassword = false,
                    this.showConfirmPassword = false
                    this.showConfirmationPopup = true;
                    this.confirmationMessage = this.$i18n.t("profileUpdateSuccess");
                }else{
                    this.resultMessage = this.$i18n.t("profileUpdateError");
                }
                this.loading = false;
                this.triedSubmit = false;
            }
        },
        alertType: function () {
            this.loading = false;
        },
        alertOutput: function () {
            this.loading = false;
            // Show pop up in case it is a string error
            // In case it is an array, it is shown on the field
            if (typeof this.alertOutput === 'string' || this.alertOutput instanceof String) {
                alert(this.alertOutput);
            }
        }
    }
}

</script>

<style></style>